export let displayedColumns: string[] = ['basinName', 'sectionBasinsCodes'];

export let displayedNames: any = {
  basinName: 'Bacino',
  sectionBasinsCodes: 'Sezione',
};
